import { render } from "./LogCallDrawer.vue?vue&type=template&id=f48d3102&scoped=true"
import script from "./LogCallDrawer.vue?vue&type=script&lang=js"
export * from "./LogCallDrawer.vue?vue&type=script&lang=js"

import "./LogCallDrawer.vue?vue&type=style&index=0&id=f48d3102&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f48d3102"]])

export default __exports__